/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import InstaPostPopovers from './InstaPostPopovers';
import { IproductsShopifyData, PixleeAlbum } from './pixlee-types';

function PixleePost({
  data,
  index,
  productsShopifyData,
  isPageLayout = false,
}: {
  data: PixleeAlbum;
  index: number;
  productsShopifyData?: IproductsShopifyData;
  isPageLayout?: boolean;
}) {
  const [postTitle, setPostTitle] = useState(
    data.photo_title ? data.photo_title.split(' ').splice(0, 20).join(' ') : ''
  );
  return data.pixlee_cdn_photos.medium_url ? (
    <div id={data.id.toString()} className={`post post-${data.id}`} key={data.id}>
      <div className={`post__image-wrapper post__image-wrapper-${data.id}`}>
        <img
          className={`post__image-${index} post__image-${data.id} img-fluid post__image`}
          src={data.pixlee_cdn_photos.medium_url}
          alt={data.alt_text}
        />
        <InstaPostPopovers
          data={data}
          item={{
            placement: 'bottom-start',
            boundariesElement: document.querySelector<HTMLElement>(`.post__image-${index}`),
            flip: false,
          }}
          productsShopifyData={productsShopifyData}
        />
      </div>
      <div className="post__info d-md-flex">
        <div className="post__titles">
          <p className="small-p">
            {isPageLayout && (
              <span>
                <img src={data.avatar_url} alt="" className="img-fluid post__avatar" />
              </span>
            )}
            <span className="black post__username">@{data.user_name}</span>
            {isPageLayout && (
              <>
                {postTitle}{' '}
                {data.photo_title && data.photo_title.split(' ').length > 20 && postTitle.split(' ').length <= 20 ? (
                  <span
                    role="button"
                    onClick={() => {
                      setPostTitle(data.photo_title);
                    }}
                  >
                    <u>Read More</u>
                  </span>
                ) : postTitle.split(' ').length > 20 ? (
                  <span role="button" onClick={() => setPostTitle(data.photo_title.split(' ').splice(0, 20).join(' '))}>
                    <u>Read less</u>
                  </span>
                ) : (
                  ''
                )}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  ) : null;
}

export default PixleePost;
